export default __webpack_public_path__ + "static/media/Dinosaurs_18.61555592.png";